import React, { useState } from 'react'
import Slider from "react-slick";

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import slide1 from "../../../assets/mobile-slider1.png"
import slide2 from "../../../assets/mobile-slider2.png"
import slide3 from "../../../assets/mobile-slider3.png"
import slide4 from "../../../assets/mobile-slider4.png"


import leftArrow from "../../../assets/leftArrow.png"
import rightArrow from "../../../assets/rightArrow.png"


import "./bottomSection.css";

const BottomSection = () => {
  const [sliderRef, setSliderRef] = useState(null)

  const settings = {
    // removes default buttons
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  };
  return (
    <div className='bottomSection-container' >

<div className='controls-mobile'>
     
     <img src={leftArrow}  className="desktopCaraousePrevButton" onClick={sliderRef?.slickPrev}/>

     <img src={rightArrow} className="desktopCaraouseNextButton" onClick={sliderRef?.slickNext}/>
 

      </div>


<Slider {...settings} ref={setSliderRef}>

<div className = 'bottomBanner'>
<img src={slide1}  style={{width : "100%"}}/>
  </div>   
  <div className = 'bottomBanner'>
<img src={slide2}  style={{width : "100%"}}/>
  </div>   
  <div className = 'bottomBanner'>
<img src={slide3}  style={{width : "100%"}}/>
  </div>   
  <div className = 'bottomBanner'>
<img src={slide4}  style={{width : "100%"}}/>
  </div>   
</Slider>



    </div>
  )
}

export default BottomSection